import { ContentCard } from '@mews-commander/ui';
import { Stack } from '@optimus-web/core';
import { AccountType } from '@mews-commander/data-access';
import { WithAccountId, WithScope } from '@mews-commander/types';
import { TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import AccountMergeForm from './AccountMergeForm';
import AccountMergeSuggestionBanner from './AccountMergeSuggestionBanner';

interface AccountMergeSuggestionProps {
    mergeSuggestionAccountId?: string;
    accountType: AccountType;
    readOnlyForm?: boolean;
}

type AccountMergeProps = WithAccountId & WithScope & AccountMergeSuggestionProps;

const AccountMerge = ({ accountId, mergeSuggestionAccountId, scope, accountType, readOnlyForm }: AccountMergeProps) => (
    <ContentCard title={<LocalizedText textKey={TextKey.Merge} />}>
        <Stack spacing="100" vertical>
            {mergeSuggestionAccountId ? (
                <AccountMergeSuggestionBanner
                    otherAccountId={mergeSuggestionAccountId}
                    accountId={accountId}
                    accountType={accountType}
                />
            ) : null}
            <AccountMergeForm
                accountId={accountId}
                form={scope}
                accountType={accountType}
                readOnlyForm={readOnlyForm}
            />
        </Stack>
    </ContentCard>
);

export default AccountMerge;
